import MontserratRegular from './Montserrat-regular.ttf';
import MontserratBold from './Montserrat-bold.ttf';
import MontserratBoldItalic from './Montserrat-bolditalic.ttf';
import MontserratItalic from './Montserrat-italic.ttf';

function addFonts() {
  const style = document.createElement('style');
  style.appendChild(
    document.createTextNode(`
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${MontserratRegular});
  }
  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${MontserratBold});
  }
  @font-face {
    font-family: 'Montserrat';
    font-style: italic;
    font-weight: 700;
    font-display: swap;
    src: url(${MontserratBoldItalic});
  }
  @font-face {
    font-family: 'Montserrat';
    font-style: italic;
    font-weight: 500;
    font-display: swap;
    src: url(${MontserratItalic});
  }
  `)
  );
  document.head.appendChild(style);
}

addFonts();
